import React, { useState } from 'react';
import AuthField from './AuthField';
import { Alert, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

export default function SignInForm({ onSignedIn, onForgotPassword }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const data = await api.post('/api/auth/login', { email, password });
      onSignedIn(data.user, data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="auth-form" onSubmit={submit} noValidate>
      <AuthField
        label="Email"
        icon="mail"
        type="email"
        value={email}
        onChange={setEmail}
        placeholder="you@example.com"
        autoComplete="email"
        required
      />
      <AuthField
        label="Password"
        icon="lock"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder="Your password"
        autoComplete="current-password"
        required
      />
      {error && <Alert kind="error">{error}</Alert>}
      <button type="submit" className="btn btn-gradient btn-lg btn-block" disabled={busy}>
        {busy ? <Spinner label="Signing in" /> : 'Sign in'}
      </button>
      <button type="button" className="link-btn" style={{ alignSelf: 'center' }} onClick={onForgotPassword}>
        Forgot your password?
      </button>
    </form>
  );
}
